import { RefObject, useEffect } from 'react';

const REVEAL_SELECTOR = '[data-home-reveal]';
const VISIBLE_CLASS = 'is-visible';

export const useHomeScrollReveal = (
  rootRef: RefObject<HTMLElement>,
  refreshKey: string
) => {
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    const elements = Array.from(
      root.querySelectorAll<HTMLElement>(REVEAL_SELECTOR)
    );

    if (
      typeof window.IntersectionObserver === 'undefined' ||
      window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
    ) {
      elements.forEach((element) => element.classList.add(VISIBLE_CLASS));
      return;
    }

    const initialViewportLimit = window.innerHeight * 0.94;
    elements.forEach((element) => {
      if (element.getBoundingClientRect().top < initialViewportLimit) {
        element.classList.add(VISIBLE_CLASS);
      }
    });

    root.classList.add('home-motion-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(VISIBLE_CLASS);
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -10% 0px',
      }
    );

    elements
      .filter((element) => !element.classList.contains(VISIBLE_CLASS))
      .forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, [refreshKey, rootRef]);
};
